const errorRoute = (next, errorCode = 404) => next({
  name: 'error',
  params: { errorCode }
});

const validateContentTypeUuid = (uuid, contentType, next) => {
  if (!uuid || !contentType) {
    errorRoute(next, 404);
  }

  if (!uuid.startsWith(`${contentType}_`)) {
    errorRoute(next, 404);
  }

  next();
};

const validateWorkspace = (routeName, workspace, isCentralizedWorkspace, next) => {
  if (!routeName) {
    errorRoute(next, 404);
  }

  if (routeName === 'candidature-spontanee-list' && workspace !== 'spontaneous') {
    errorRoute(next, 404);
  }

  if (routeName === 'model-offers-list' && !isCentralizedWorkspace) {
    errorRoute(next, 404);
  }

  next();
};

// eslint-disable-next-line import/prefer-default-export
export { validateContentTypeUuid, validateWorkspace };
